import { useState, type ReactNode } from "react";
import { Activity, BarChart3, CalendarClock, DatabaseZap, FlaskConical, LineChart, LogOut, Menu, Search, X } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth.js";
import { ScheduleDialog } from "./ScheduleDialog.js";

const navigation = [
  {to: "/", label: "Portfolio", icon: LineChart, end: true},
  {to: "/research", label: "Research overview", icon: BarChart3},
  {to: "/playground", label: "Policy playground", icon: FlaskConical},
  {to: "/analyses", label: "Analysis library", icon: Search},
  {to: "/jobs", label: "Jobs & schedule", icon: Activity},
  {to: "/data-health", label: "Data health", icon: DatabaseZap},
];

export function AppLayout({children}: {children: ReactNode}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const {user, signOut} = useAuth();
  const location = useLocation();
  return <div className="shell">
    <aside className={`sidebar ${mobileOpen ? "open" : ""}`}>
      <div className="sidebar-head"><div className="brand"><span className="brand-mark">S</span><div><strong>Signum</strong><small>Quantitative review</small></div></div>
        <button className="icon-button mobile-only" onClick={() => setMobileOpen(false)} aria-label="Close menu"><X size={18}/></button></div>
      <nav>{navigation.map(({to, label, icon: Icon, end}) => <NavLink key={to} to={to} end={end} onClick={() => setMobileOpen(false)}>
        <Icon size={18}/><span>{label}</span></NavLink>)}</nav>
      <div className="sidebar-foot"><div className="environment"><span className="pulse-dot"/><span>Production workspace</span></div>
        <div className="account"><span className="avatar">{user?.email[0]?.toUpperCase()}</span><div><strong>{user?.displayName ?? "Data reviewer"}</strong><small>{user?.email}</small></div>
          <button className="icon-button" onClick={signOut} aria-label="Sign out"><LogOut size={16}/></button></div></div>
    </aside>
    {mobileOpen && <button className="scrim" onClick={() => setMobileOpen(false)} aria-label="Close navigation"/>}
    <main className="main"><header className="topbar"><button className="icon-button mobile-only" onClick={() => setMobileOpen(true)} aria-label="Open menu"><Menu size={20}/></button>
      <div className="crumb">{titleFor(location.pathname)}</div><button className="button primary compact" onClick={() => setScheduleOpen(true)}><CalendarClock size={16}/> New analysis</button></header>
      <div className="content">{children}</div></main>
    <ScheduleDialog open={scheduleOpen} onClose={() => setScheduleOpen(false)}/>
  </div>;
}

function titleFor(path: string) {
  if (path.includes("/candidates/")) return "Candidate evidence review";
  if (/^\/analyses\/.+/.test(path)) return "Analysis review";
  if (path.startsWith("/analyses")) return "Analysis library";
  if (path.startsWith("/jobs")) return "Jobs & schedule";
  if (path.startsWith("/data-health")) return "Data health";
  if (path.startsWith("/research")) return "Research overview";
  if (path.startsWith("/playground")) return "Policy playground";
  return "Model portfolio";
}
